import { Component, Input, EventEmitter, Output,ElementRef, ViewChild  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

import { AnalysisOptionsComponent } from '../../../tools/analysis-options/analysis-options.component';

import { AnalysisServiceService } from '../../../services/analysis-service/analysis-service.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ProyectosService } from '../../../services/proyectos.service';
import { FacadeService } from '../../../services/facade.service';

//Variables del Navegador
type MenuItem = 'summary' | 'rank' | 'edits' | 'charts';


//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
  type: string;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

interface Project {
  word: string;
  count: number;
  tag: string;
}

@Component({
  selector: 'coca',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    MatTableModule,
    HttpClientModule],
  templateUrl: './coca.component.html',
  styleUrl: './coca.component.css'
})
export class CocaComponent {
  selectedMenuItem: MenuItem = 'rank';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component

  englishType: string = 'british';//Variable de tipo de Ingles para cambiar la pestaña

  isIconRotated = false;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  verifyLoaderActive2: boolean;

  @Output() textItemSelected = new EventEmitter<boolean>();

  activeEyeIcon: HTMLImageElement | null = null;

  //Valores para expandir cada Cuadro
  public isExpanded = {

  };

  public colors = [
    '#32cd32',
    '#9400d3',
    '#1e90ff',
    '#b22222',
    '#add8e6',
    '#bc8f8f',
    '#daa520',
    '#cd853f',
    '#20b2aa',
    '#bdb76b',
    '#156d31',
    '#87cefa',
    '#4b0082',
    '#00bfff',
    '#008080',
    '#ffa07a',
    '#0000cd',
    '#8b0000',
    '#deb887',
    '#00ffff',
    '#2a3654',
    '#2a3654'
  ]

  public data: Data = {
  };

  public rank_data;

  // Pagina de Summary 2
  public summary = {
    coverage: {
      counted: null,
      no_counted: null,
      value: null
    },
    tokens: null,
    types: null,
    tokens_counted: null,
    types_counted:null,
    elements: null,
    total_tokens: null,
    total_types: null,
    mean_token: null,
    mean_type: null,
    mean_100_tokens: null,
    mean_100_types: null,
    fifty_types: null,
    sixty_types: null,
    seventy_types: null,
    eighty_types: null,
    fifty_tokens: null,
    sixty_tokens: null,
    seventy_tokens: null,
    eighty_tokens: null
  };

  // Variables de la pagina de Summary 2
  public coverage: number | undefined | null;
  public tokens: number | undefined | null;
  public types: number | undefined | null;
  public elements: number | undefined | null;
  public total_tokens: number | undefined | null;
  public total_types: number | undefined | null;
  public mean_token: number | undefined | null;
  public mean_type: number | undefined | null;
  public mean_100_tokens: number | undefined | null;
  public mean_100_types: number | undefined | null;
  public fifty_types: number | undefined | null;
  public sixty_types: number | undefined | null;
  public seventy_types: number | undefined | null;
  public eighty_types: number | undefined | null;
  public fifty_tokens: number | undefined | null;
  public sixty_tokens: number | undefined | null;
  public seventy_tokens: number | undefined | null;
  public eighty_tokens: number | undefined | null;

  public total_tokens_estimated: number | undefined | null;

  //Variables de la pagina Edits 3
  displayedColumns: string[] = ['word', 'count', 'tag'];
  projects = new MatTableDataSource<Project>([
  ]);

  public ishighlighted: any = {};
  project_data: any;
  private proyectoSub;

  public hideEyeIconsForSafari1561 = false;

  constructor(
    private analysisService: AnalysisServiceService,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService
  ) {
    this.checked = true;
    this.divideData();
  }

  ngOnInit(): void {
    localStorage.setItem("actual","coca")
    // Funcion para saber si el tipo de Ingles es British o American
    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    this.analysisService.currentEnglishType.subscribe(type => {
      this.englishType = type;
       if(sessionStorage.getItem("id_project")){
        this.initparser();
       }
    });
    this.initSubscribe()
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

            this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

  }

  ngOnDestroy(): void {
    this.proyectoSub?.unsubscribe();
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: COCA / BNC--")
        this.project_data = proyecto;
  
         for (const key in this.ishighlighted) {
          this.ishighlighted[key] = false;
        }
        if(sessionStorage.getItem("id_project")){
        this.seeAllIconSrc= '../../assets/images/eye-icon.svg';
        this.seeAllActive = false;
        this.initparser();
        }
      });
    }
  }

  status: any;
  async initparser() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "coca"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("coca");
      
      //  Guardamos el estado actual de los ojos antes de resetear
      const previousHighlights = { ...this.ishighlighted };

      if (memoryStorage) {
        if(memoryStorage !== "-"){
          try {
            // Si existe, convertirlo de JSON string a objeto y asignarlo
          let respuesta = JSON.parse(memoryStorage);
          this.summary = respuesta.summary
          // Asignar los valores de tokens_estimated a editWords
          // Inicializar projects con datos dinámicos
          this.projects = new MatTableDataSource<Project>(
            respuesta.tokens_estimated.map(item => ({
              word: item.word,
              count: item.count,
              tag: item.tag
            }))
          );
  
          this.total_tokens_estimated = respuesta.total_tokens_estimated ;
  
  
          //console.log("PRUEBA de storage"+JSON.stringify(this.summary,null,2))
          let acumulativo = 0;
          let maxValue=0;
          let barchar1data = {
            data: [],
            label: '',
            backgroundColor: [
              '#32cd32',
              '#9400d3',
              '#1e90ff',
              '#b22222',
              '#add8e6',
              '#bc8f8f',
              '#daa520',
              '#cd853f',
              '#20b2aa',
              '#bdb76b',
            ],
            // Hace las barras más delgadas
            barThickness: 40,
          };
          let barchar2data = {
            data: [],
            label: '',
            backgroundColor: [
              '#156d31',
              '#87cefa',
              '#4b0082',
              '#00bfff',
              '#008080',
              '#ffa07a',
              '#0000cd',
              '#8b0000',
              '#deb887',
              '#00ffff',
            ],
            // Hace las barras más delgadas
            barThickness: 40,
          };
          // console.log(respuesta.rank)
          for (let index = 0; index < respuesta.rank.length; index++) {
            let element = respuesta.rank[index];
            this.isExpanded[element.label] = this.isExpanded[element.label] ?? false
             //  restauramos estado anterior si existía
            this.ishighlighted[element.label] =
              previousHighlights[element.label] ?? false;
            // const cantidadLlaves = this.getObjectKeys(respuesta.rank[index].words).length;
            const cantidadLlaves = respuesta.rank[index].total;
            // console.log (cantidadLlaves/this.summary.coverage.counted);
            if (index != 10) {
              //Punto intermedio, no hay que volver a sumar el porcentage
              acumulativo += cantidadLlaves / this.summary.types;
            }
            
            if (index == 20) {
              //Off list no hay que sumar, hay que restar
              acumulativo -= cantidadLlaves / this.summary.types;
            }
  
            const value = (cantidadLlaves / this.summary.types) * 100; 
  
            if (value > maxValue) { 
              maxValue = value; 
            }// Actualizar el valor máximo
  
            if (index <= 9) {
              barchar1data.data.push((cantidadLlaves / this.summary.types) * 100)
            } else {
              barchar2data.data.push((cantidadLlaves / this.summary.types) * 100)
            }
            respuesta.rank[index].text = cantidadLlaves / this.summary.types
            respuesta.rank[index].cumul = acumulativo
            respuesta.rank[index].cantidad = cantidadLlaves
            respuesta.rank[index].color = index
          }
          // console.log(acumulativo)
          // Filtramos para ocultar el label "0-10K"
          this.rank_data = respuesta.rank.filter(item => item.label !== '0-10K');

          // console.log(this.rank_data);
          this.barChartData.datasets = [barchar1data]
          // barchar2data.data = barchar2data.data.slice(1); // Ignora el primer valor
          // barchar2data.backgroundColor = barchar2data.backgroundColor.slice(1); // Ignora el primer color
          this.barChartData2.datasets = [barchar2data]
          this.updateChartOptions(Math.ceil(maxValue));
        } catch (error) {
          console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('coca');
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject =false;
          this.proyectoService.updateloader(false);
        }
      }
      }else{
        sessionStorage.setItem("coca", "-");
         //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let respuesta;
          let textUID = sessionStorage.getItem('text_UID');
          if (this.englishType == 'british') {
            respuesta = await this.fachada.getBncOfProject(this.http, textUID, "");
          } else {
            // TODO: Cambiar a COCA cuando llegue el momento
            console.log("Vamos a llamar a COCA")
            respuesta = await this.fachada.getCocaOfProject(this.http, textUID, "");
          }
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("coca", JSON.stringify(respuesta));
          this.summary = respuesta.summary
           this.projects = new MatTableDataSource<Project>(
            respuesta.tokens_estimated.map(item => ({
              word: item.word,
              count: item.count,
              tag: item.tag
            }))
          );
          this.total_tokens_estimated = respuesta.total_tokens_estimated ;
          let acumulativo = 0;
          let maxValue=0;
          let barchar1data = {
            data: [],
            label: '',
            backgroundColor: [
              '#32cd32',
              '#9400d3',
              '#1e90ff',
              '#b22222',
              '#add8e6',
              '#bc8f8f',
              '#daa520',
              '#cd853f',
              '#20b2aa',
              '#bdb76b',
            ],
            // Hace las barras más delgadas
            barThickness: 40,
          };
          let barchar2data = {
            data: [],
            label: '',
            backgroundColor: [
              '#156d31',
              '#87cefa',
              '#4b0082',
              '#00bfff',
              '#008080',
              '#ffa07a',
              '#0000cd',
              '#8b0000',
              '#deb887',
              '#00ffff',
            ],
            // Hace las barras más delgadas
            barThickness: 40,
          };
          // console.log(respuesta.rank)
          for (let index = 0; index < respuesta.rank.length; index++) {
            let element = respuesta.rank[index];
            this.isExpanded[element.label] = this.isExpanded[element.label] ?? false
            this.ishighlighted[element.label] = this.ishighlighted[element.label] ?? false
            // const cantidadLlaves = this.getObjectKeys(respuesta.rank[index].words).length;
            const cantidadLlaves = respuesta.rank[index].total;
            // console.log (cantidadLlaves/this.summary.coverage.counted);
            if (index != 10) {
              //Punto intermedio, no hay que volver a sumar el porcentage
              acumulativo += cantidadLlaves / this.summary.types;
            }
            
            if (index == 20) {
              //Off list no hay que sumar, hay que restar
              acumulativo -= cantidadLlaves / this.summary.types;
            }
  
            const value = (cantidadLlaves / this.summary.types) * 100; 
  
            if (value > maxValue) { 
              maxValue = value; 
            }// Actualizar el valor máximo
  
            if (index <= 9) {
              barchar1data.data.push((cantidadLlaves / this.summary.types) * 100)
            } else {
              barchar2data.data.push((cantidadLlaves / this.summary.types) * 100)
            }
            respuesta.rank[index].text = cantidadLlaves / this.summary.types
            respuesta.rank[index].cumul = acumulativo
            respuesta.rank[index].cantidad = cantidadLlaves
            respuesta.rank[index].color = index
          }
          // console.log(acumulativo)
          // Filtramos para ocultar el label "0-10K"
          this.rank_data = respuesta.rank.filter(item => item.label !== '0-10K');

          // console.log(this.rank_data);
          this.barChartData.datasets = [barchar1data]


          // barchar2data.data = barchar2data.data.slice(1); // Ignora el primer valor
          // barchar2data.backgroundColor = barchar2data.backgroundColor.slice(1); // Ignora el primer color
          this.barChartData2.datasets = [barchar2data]

          this.updateChartOptions(Math.ceil(maxValue));
          this.status = 200
        } catch (error) {
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (coca)");
            sessionStorage.removeItem('coca');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('coca');
          }
          this.status = error?.status;

        }finally{
          if(this.status === 0){
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
             setTimeout(() => {
              this.initparser();
            }, 100);
          }else{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
          }
          
          
        }
      }
       }else{
      console.log(`coca no es la pantalla actual así que bloqueamos peticiones`)
    }
   
  }

   public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  updateChartOptions(maxValue: number) {
    const stepSize = Math.ceil(maxValue / 5); // Ajustar el tamaño del paso en función del valor máximo
  
    this.barChartOptions = {
      scales: {
        x: {
          grid: {
            display: false, // Ocultar las líneas verticales
          },
        },
        y: {
          min: 0,
          max: maxValue, // Ajuste según el valor máximo calculado
          ticks: {
            stepSize: stepSize, // Incrementos calculados
            callback: function (value) {
              return value + '%'; // Mostrar el símbolo % en las etiquetas
            }
          },
          border: {
            display: false, // Eliminar el borde del eje Y
          },
          grid: {
            color: '#E0E0E0', // Color de las líneas horizontales
          },
        },
      },
      plugins: {
        legend: {
          display: false, // Ocultar la leyenda
        },
        datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
      },
    };
  }
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // Lista de palabras con su tag y conteo
  editWords = [];

  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData: DividedData = {};


  divideData() {
    for (const key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        const items = this.data[key];
        const chunkSize = Math.ceil(items.length / 2);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize),
        ];
      }
    }
  }

  toggleIcon() {
    this.isIconRotated = !this.isIconRotated;
  }

  resetIcon() { this.isIconRotated = false; }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }

  toggleExpandAll() {
    const allExpanded = Object.values(this.isExpanded).every(value => value);

    Object.keys(this.isExpanded).forEach(identifier => {
      this.isExpanded[identifier] = !allExpanded;

    });
    this.showAll = allExpanded; 

  }
  
  showAll: boolean = true; 

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
    if (menuItem === 'edits' || menuItem === 'summary') {
      this.textItemSelected.emit(true);
    } else {
      this.textItemSelected.emit(false);
    }
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  getTitleText(): string {
    return this.englishType === 'british' ? 'Lexis: British National Corpus' : 'Lexis: Corpus Of Contemporary <br> American English';
  }

  getText(): string {
    return this.englishType === 'british' ? 'This section uses the British National Corpus (BNC) list to give exact frequencies, instead of relying on word families. Please click <a>here</a> for more information.' : 'This section uses the Corpus of Contemporary American English (COCA) lists to give exact frequencies, instead of relying on word families. Please click here for more information.';
  }

  getTextToolTip(): string {
    return this.englishType === 'british' ? 'This ranks all the unique words in your text, according to how commonly used they are in British English as per the British National Corpus, and takes the medium word (also called the 50th percentile). The number shown here is the position (within all the words in British English) of that 50th percentile word.' : 'This ranks all the unique words in your text, according to how commonly used they are in American English as per the Corpus of Contemporary American English, and takes the medium word (also called the 50th percentile). The number shown here is the position (within all the words in American English) of that 50th percentile word.';
  }

  getButtonText(): string {
    return this.englishType === 'british' ? 'BNC' : 'COCA';
  }

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 100,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: 10,  // Incrementos de 5% en 5%
          callback: function (value) {
            return value + '%';  // Mostrar el símbolo % en las etiquetas
          }
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };


  public barChartType = 'bar' as const;

  public barChartData: ChartData<'bar'> = {
    labels: ["0-1K", "1-2K", "2-3K", "3-4K", "4-5K", "5-6K", "6-7K", "8-9K", "9-10K"],
    datasets: [
      {
        data: [],
        label: '',
        backgroundColor: [
          '#32cd32',
          '#9400d3',
          '#1e90ff',
          '#b22222',
          '#add8e6',
          '#bc8f8f',
          '#daa520',
          '#cd853f',
          '#20b2aa',
          '#bdb76b',
        ],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };

  public barChartType2 = 'bar' as const;

  public barChartData2: ChartData<'bar'> = {
    labels: ["0-10K", "10-20K", "20-30K", "30-40K", "40-50K", "50-60K", "60-70K", "80-90K", "90-100K"],
    datasets: [
      {
        data: [],
        label: '',
        backgroundColor: [
          '#156d31',
          '#87cefa',
          '#4b0082',
          '#00bfff',
          '#008080',
          '#ffa07a',
          '#0000cd',
          '#8b0000',
          '#deb887',
          '#00ffff',
        ],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };




  export_detallado() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
        if (this.englishType == 'british') {
          this.fachada.detail_export("taggedlexical-bnc", respaldo_ID.value)
        } else {
          this.fachada.detail_export("taggedlexical-coca", respaldo_ID.value)
        }

      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }

    //Para el cambio de color de los ojos
// Para el cambio de color de los ojos
toggleEyeIcon(word_dict: string, index = 0): void {
  this.ishighlighted[word_dict] = !this.ishighlighted[word_dict];

  if (this.ishighlighted[word_dict]) {
    //  Si enciendo una categoría, recalculo con todas las que están activas
    const categoriasActivas = this.rank_data.filter(
      item => item.label !== '0-10k' && this.ishighlighted[item.label]
    );
    this.proyectoService.realizarMarcadoTodasLasCategorias(categoriasActivas,this.http);
  } else {
    //  Si apago una categoría, recalculo con las que queden activas
    const categoriasActivas = this.rank_data.filter(
      item => item.label !== '0-10k' && this.ishighlighted[item.label]
    );
    if (categoriasActivas.length > 0) {
      this.proyectoService.realizarMarcadoTodasLasCategorias(categoriasActivas,this.http);
    } else {
      //  Si ya no queda ninguna activa, limpio el texto
      this.proyectoService.undoMarcadoMultiple(this.http);
    }
  }

  //  Sincronizar con See All
  this.syncSeeAllState();
}





  seeAllActive: boolean = false;
  seeAllIconSrc: string = '../../assets/images/eye-icon.svg'; // Controla el ícono del botón "See All"
toggleSeeAll(): void {
  const allOn = !this.seeAllActive;

  if (allOn) {
    //  Encender todas las categorías excepto 0-10k
    this.rank_data.forEach(item => {
      if (item.label !== '0-10k') {
        this.ishighlighted[item.label] = true;
      }
    });

    //  Resaltar todas en el texto
    this.proyectoService.realizarMarcadoTodasLasCategorias(this.rank_data, this.http);
  } else {
    // ✅ Apagar todas excepto 0-10k
    this.rank_data.forEach(item => {
      if (item.label !== '0-10k') {
        this.ishighlighted[item.label] = false;
      }
    });

    //  Quitar todos los resaltados
    this.proyectoService.undoMarcadoMultiple(this.http);
  }

  this.seeAllActive = allOn;
  this.updateSeeAllIcon();

  this.syncSeeAllState();
}



// -------------------------------------
// 🔥 Mantener el estado correcto de See All
// -------------------------------------
private syncSeeAllState(): void {
  const categoriasValidas = this.rank_data.filter(
    item => item.label !== '0-10k' && item.cantidad > 0
  );

  const allActive = categoriasValidas.every(
    item => this.ishighlighted[item.label] === true
  );

  const noneActive = categoriasValidas.every(
    item => this.ishighlighted[item.label] === false
  );

  this.seeAllActive = allActive;
  this.updateSeeAllIcon();

  // 🔥 Si no hay ninguna activa, limpiar texto
  if (noneActive) {
    this.proyectoService.undoMarcadoMultiple(this.http);
  }
}



// -------------------------------------
// 🔥 Actualizar el ícono del botón See All
// -------------------------------------
private updateSeeAllIcon(): void {
  this.seeAllIconSrc = this.seeAllActive
    ? '../../assets/images/yellow_icons/eye-on-icon.svg'
    : '../../assets/images/eye-icon.svg';
}

private updateSeeAllState(): void {
  const categorias = Object.keys(this.ishighlighted)
    .filter(cat => cat !== '0-10k'); // Ignorar 0-10k

  this.seeAllActive = categorias.every(cat => this.ishighlighted[cat]);
  this.updateSeeAllIcon();
}


  export_tagger() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
        if (this.englishType == 'british') {
          this.fachada.tagger_export("taggedlexical-bnc", respaldo_ID.value)
        } else {
          this.fachada.tagger_export("taggedlexical-coca", respaldo_ID.value)
        }
      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }
}
